export default __webpack_public_path__ + "static/media/pb-img.9be6df32.png";